// packages/shared-hooks/src/lead-activity/useCreateLeadCommunication.ts
//
// `POST /leads/:leadId/communications` — append a typed CALL/MESSAGE
// communication (#1807). The success path invalidates the activity feed
// so the freshly-emitted CALL/MESSAGE row appears without a manual refetch.
import { useMutation, useQueryClient } from '@tanstack/react-query';
import {
  LeadCommunicationResponseSchema,
  type CreateLeadCommunicationRequest,
  type LeadCommunicationResponse,
} from '@magimp/shared';
import { useApiClient } from '../api/context.js';
import { leadActivityKeys } from './keys.js';

export function useCreateLeadCommunication(leadId: string) {
  const client = useApiClient();
  const qc = useQueryClient();
  return useMutation<LeadCommunicationResponse, unknown, CreateLeadCommunicationRequest>({
    mutationFn: (input) =>
      client.post<LeadCommunicationResponse>(
        `/leads/${leadId}/communications`,
        input,
        {},
        LeadCommunicationResponseSchema,
      ),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: leadActivityKeys.forLead(leadId) });
    },
  });
}
